// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    ...rfqQuoteDetailsInformationStyles.expirationDateGridItem,
    css: css`
        ${rfqQuoteDetailsInformationStyles.expirationDateGridItem?.css}
        & > div[class^="FormFieldStyle"] {
            width: 50%;

            ${screen("lte", "md")`
                    width: 66%;
                `}
            ${screen("lte", "xs")`
                    width: 100%;
                `}
        }
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        ...rfqQuoteDetailsInformationStyles.expirationDateDatePicker?.cssOverrides,
        datePicker: css`
            width: auto;
        `,
    },
};
